import { Record } from "immutable";

const SummaryResultRecord = Record({
  totalES: { data: [] },
  totalESIndex: {
    index: null,
    data: [],
    attrCount: null
  },
  comment: "",
  initComment: ""
});

class SummaryResult extends SummaryResultRecord {}

export default SummaryResult;



// WEBPACK FOOTER //
// ./src/models/SummaryResult.js